var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.437 11.516 10.012 2.12A2.3 2.3 0 0 0 8 .959 2.3 2.3 0 0 0 5.988 2.12L.563 11.516a2.3 2.3 0 0 0 0 2.322A2.3 2.3 0 0 0 2.575 15h10.85c.84 0 1.592-.434 2.012-1.162.42-.727.42-1.595 0-2.322M7.25 5.5a.75.75 0 0 1 1.5 0V9a.75.75 0 0 1-1.5 0zM8 12.569a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2"
  })));
};
export default SvgWarningIcon;